import { CartResponse } from "./Models/EchoRequest";

export interface EVChargingStatus {
    state: number;
    plugState: number;
    current: number;
    voltage: number;
    power: number;
    energy: number;
    sessionID: number;
}

export interface SmartschankStatus {
    status: string;
}

export class BackendAPI {
    private readonly REMOTE_API_URL = ' https://caridad-proglottidean-expectably.ngrok-free.dev';

    public async handleDeliveryMethod(method: 'email' | 'sms', journeyID: string, contactInfo: string): Promise<any> {
        try {
            const response = await fetch(`${this.REMOTE_API_URL}/deliverymethod/${journeyID}/${method}?target=${contactInfo}`, {
                method: 'GET',
            });
            return response;
        } catch (error) {
            console.error('Error setting delivery method:', error);
        }
    };

    public async executeDemoApiCharging(): Promise<CartResponse> {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 50000);

        try {
            const response = await fetch(`${this.REMOTE_API_URL}/democase`, {
                method: 'GET',
                signal: controller.signal
            });
            if (!response.ok) {
                throw new Error('Failed to execute smartschank');
            }
            return await response.json();
        } finally {
            clearTimeout(timeoutId);
        }
    }

    public async getEvChargingStatus(): Promise<EVChargingStatus> {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 500);

        try {
            const response = await fetch(`${this.REMOTE_API_URL}/evcharging/status`, {
                signal: controller.signal
            });
            if (!response.ok) {
                throw new Error('Failed to fetch charging status');
            }
            return await response.json();
        } finally {
            clearTimeout(timeoutId);
        }
    }

    public async executeEvCharging(): Promise<CartResponse> {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 50000);

        try {
            const response = await fetch(`${this.REMOTE_API_URL}/evcharging`, {
                method: 'GET',
                signal: controller.signal
            });
            if (!response.ok) {
                throw new Error('Failed to execute smartschank');
            }
            return await response.json();
        } finally {
            clearTimeout(timeoutId);
        }
    }

    public async getSmartschankStatus(): Promise<SmartschankStatus> {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 500);

        try {
            const response = await fetch(`${this.REMOTE_API_URL}/smartschank/status`, {
                signal: controller.signal
            });
            if (!response.ok) {
                throw new Error('Failed to fetch smartschank status');
            }
            return await response.json();
        } finally {
            clearTimeout(timeoutId);
        }
    }

    public async executeSmartschank(): Promise<CartResponse> {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 50000);

        try {
            const response = await fetch(`${this.REMOTE_API_URL}/smartschank`, {
                method: 'GET',
                signal: controller.signal
            });
            if (!response.ok) {
                throw new Error('Failed to execute smartschank');
            }
            return await response.json();
        } finally {
            clearTimeout(timeoutId);
        }
    }
}
